export const FORGOT_PASSWORD_INITIAL_VALUES = {
  userName: '',
  lastName: '',
  birthDate: new Date(''),
  lastFourDigitsOfSsn: '',
};

export const FORGOT_PASSWORD_QUERY_KEY = ['forgot password'] as const;
